'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

BreadcrumbsDirectiveController=function(){_createClass(BreadcrumbsDirectiveController,null,[{key:'$inject',get:function()
{
return['breadcrumbsService'];
}}]);

function BreadcrumbsDirectiveController(breadcrumbsService){_classCallCheck(this,BreadcrumbsDirectiveController);
this._breadcrumbService=breadcrumbsService;
}_createClass(BreadcrumbsDirectiveController,[{key:'crumbs',get:function()

{
return this._breadcrumbService.crumbs;
}}]);return BreadcrumbsDirectiveController}();let


BreadcrumbsDirective=function(_BaseControllerBacked){_inherits(BreadcrumbsDirective,_BaseControllerBacked);function BreadcrumbsDirective(){_classCallCheck(this,BreadcrumbsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(BreadcrumbsDirective,[{key:'templateUrl',get:function()
{
return'/templates/directives/breadcrumbsDirective/breadcrumbsTemplate';
}},{key:'controller',get:function()

{
return BreadcrumbsDirectiveController;
}}]);return BreadcrumbsDirective}(BaseControllerBackedDirective);


module.exports=BreadcrumbsDirective;
//# sourceMappingURL=breadcrumbsDirective.js.map
